<template>
	<el-card class="menuBody" style="width: 100%;" shadow="never">
		<left-project-tree ref="projectTree" :showCheckBox="true" @checkNode="checkNode" v-show="treeType == 'project'"></left-project-tree>
		<left-floor-tree v-show="treeType == 'floor'" @chooseNode="chooseNode"></left-floor-tree>
		<el-card class="box-card">
			<div class="search-title">
				缴费报表
			</div>
			<div class="search-input-item">
				<el-select clearable size="small" v-model="treeType">
					<el-option value="project" label="按项目查询（多选）"></el-option>
					<el-option value="floor" label="按楼栋查询"></el-option>
				</el-select>
			</div>
			<div class="search-input-item">
				<el-date-picker
					v-model="query.dataRange"
					type="daterange"
					align="right"
					size="small"
					style="width: 410px"
					value-format="yyyy-MM-dd"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="pickerOptions"
				>
				</el-date-picker>
			</div>
			<div class="search-button-tools">
				<el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.report.summary'" :loading="tableLoading" @click="doSearch">查询</el-button>
				<el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.report.export'" v-debounce @click="doExport">导出</el-button>
			</div>
			<el-table :data="tableData" row-key="chargeItem" border :stripe="true" v-loading="tableLoading">
				<el-table-column align="right" width="150" prop="chargeItem" label="收费项目"></el-table-column>
				<el-table-column align="right" width="150" prop="apppay" label="APP"></el-table-column>
				<el-table-column align="right" width="150" prop="cashPay" label="现金"></el-table-column>
				<el-table-column align="right" width="150" prop="transPay" label="转账"></el-table-column>
				<el-table-column align="right" width="150" prop="pospay" label="POS机"></el-table-column>
				<el-table-column align="right" width="150" prop="wxpay" label="微信"></el-table-column>
				<el-table-column align="right" width="150" prop="aliPay" label="支付宝"></el-table-column>
				<el-table-column align="right" width="150" prop="bankPay" label="银行划扣"></el-table-column>
				<el-table-column align="right" width="150" prop="rushPay" label="转冲"></el-table-column>
				<el-table-column align="right" width="150" prop="otherPay" label="其他"></el-table-column>
				<el-table-column align="right" width="150" prop="total" label="合计"></el-table-column>
			</el-table>
		</el-card>
	</el-card>
</template>
<script>
import "@/assets/scss/common.scss";
import mixin from "@/mixin/index";
import { omit, assign } from "lodash";
import LeftProjectTree from "@/components/LeftProjectTree.vue";
import LeftFloorTree from "@/components/LeftFloorTree.vue";
import { findComponentDownward } from "@/assets/common/component";
export default {
	name: "MeterReportIndex",
	mixins: [mixin],
	components: { LeftProjectTree, LeftFloorTree },
	data() {
		return {
			treeType: "project",
			queryListUrl: "meter/web/report/summary",
		};
	},
	methods: {
		doSearch() {
			this.getListPost();
		},
		doExport() {
			const title = "缴费报表";
			const url = "meter/web/report/export";
			this._exportPost(title, url);
		},
		getListBefore(params) {
			return omit(params, ["page", "size"]);
		},
		getListAfter(data) {
			this.tableData = data.data;
		},
		chooseNode(data) {
			this.query = assign(this.query, data);
			this.doSearch();
		},
		checkNode(keys) {
			this.query.projectIdsStr = keys.toString();
			this.doSearch();
		},
	},
	watch: {
		treeType(newVal, oldVal) {
			if (newVal == "project") {
				delete this.query.officeId;
				delete this.query.projectId;
				delete this.query.floorId;
			} else {
				delete this.query.projectIdsStr;
				this.$refs.projectTree;
				const tree = findComponentDownward(this.$refs.projectTree, "ElTree");
				if (tree) {
					tree.setCheckedKeys([]);
				}
			}
		},
	},
	mounted() {
		this.doSearch();
	},
};
</script>
